<template>
  <div>
    <Modal title="创建快照" v-model="createImageModal">
      <div class="req-form">
        <Form ref="createImageForm" :model="createImageForm" :rules="createImageRule" style="padding-right: 10px">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="实例名称">
            <Input v-model="server_name" :disabled="true" />
          </FormItem>
          <FormItem label="快照名称" prop="createImageName">
            <Input v-model="createImageForm.createImageName" :maxlength="255" placeholder="请填写快照名称"/>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="createImageModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { actionPrivateCloudServer } from '@/api/private-cloud/server'
export default {
  name: 'server-create-image',
  data () {
    return {
      server_id: '',
      server_name: '',
      createImageModal: false,
      createImageForm: {
        createImageName: ''
      },
      createImageRule: {
        createImageName: [
          { required: true, message: '快照名称不能为空', trigger: 'blur' }
        ]
      },
      submitting: false,
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    openModal (id, name) {
      this.server_id = id
      this.server_name = name
      this.createImageModal = true
    },
    submit () {
      this.$refs['createImageForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            createImage: {
              name: this.createImageForm.createImageName
            }
          }
          this.submitting = true
          actionPrivateCloudServer(reqData, this.server_id).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.createImageModal = false
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
